import React, { useRef, useState } from 'react'
import { FlashMessage, GlobalLoader, InputField } from '@reactiveonline/reactive_admin_shared-packages'
import { emailValidation } from '@reactiveonline/reactive_admin_shared-packages/utils'
import LanguagePicker from '../shared/LanguagePicker'

export default function New({ adminInterfaceLogo, recoverPasswordPath, loginPath }) {
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)

  const flashMessageRef = useRef(null)

  const sendRecoveryEmail = () => {
    const fd = new FormData()

    fd.append('administrator[email]', email)

    setLoading(true)
    
    Rails.ajax({
      type: 'POST',
      url: recoverPasswordPath,
      dataType: 'json',
      data: fd,
      success: res => {
        flashMessageRef.current.show(res.message, 'success')
        setLoading(false)
      },
      error: res => {
        flashMessageRef.current.show(res.error, 'error')
        setLoading(false)
      }
    })
  }

  return (
    <>
      <div className='flex-box flex-column items-center content-center authentication-wrapper'>
        <div className="auth-box">
          <div className="left-side-wrapper">
            <div className="logo">
              <img src={ adminInterfaceLogo } />
            </div>

            <div className='authentication-language-picker-wrapper'>
              <LanguagePicker />
            </div>

            <div className="headline">
              <h1 className='m-b-10'>{ Support.translations.recover_password }</h1>
              <div>{ Support.translations.recover_password_help }</div>
            </div>
            <div className="form">
              <div className="row">
                <div className="field">
                  <InputField
                    className='input-field col s12'
                    label={ Support.translations.administrator.attributes.email }
                  >
                    <input
                      type='email'
                      value={ email }
                      onChange={ e => setEmail(e.target.value) }
                    />
                  </InputField>
                </div>

                <div className="field">
                  <div className='button-wrapper items-center content-center flex-box'>
                    <div
                      className={ `btn ${ emailValidation(email) ? '' : 'disabled' } `}
                      style={{ width: '100%' }}
                      onClick={ _e => emailValidation(email) ? sendRecoveryEmail() : () => {} }
                    >
                      { Support.translations.administrator.send_recovery_instructions }
                    </div>
                  </div>
                </div>

                <div style={{ fontWeight: 0.8 }}>
                  <a 
                    href={ loginPath } 
                  >
                    { Support.translations.login }
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      { loading && <GlobalLoader fullPage/> }

      <FlashMessage ref={ flashMessageRef } />
    </>
  )
}
